import React from "react";
import { Helmet } from "react-helmet";

// HomePage CSS — custom effects (reveal, gallery, badge, btn styles)
import "../HomePage/HomePage.css";

// Page Sections
import HomeSlider from "../HomePage/HomeSlider";
import AboutSection from "../HomePage/AboutSection";
import SpecifySection from "../HomePage/SpecifySection";
import CategorySection from "../HomePage/CategorySection";
import FeaturedProducts from "../HomePage/FeaturedProducts";
import GallerySection from "../HomePage/GallerySection";
import ReviewsSection from "../HomePage/ReviewsSection";
import ContactFormSection from "../HomePage/ContactFormSection";
import BlogsSection from "../HomePage/BlogsSection";
import AlsoAvailableSection from "../HomePage/AlsoAvailableSection";
import WelcomeModal from "../HomePage/WelcomeModal";
import MarqueeStrip from "../HomePage/Marqueestrip";
import AvailableOn from "../AvailableOn/AvailableOn";

const MainContent = () => {
  return (
    <>
      <Helmet>
        <title>KUKUNAMKEEN | Kachori | SWEETS | Free Shipping | Indian Snacks</title>
        <meta
          name="description"
          content="KUKUNAMKEEN - Your Destination for Authentic Indian Snacks. Explore our range of Kachori, Sweets, Combos and more. Founded in 1965 in Jamnagar. Enjoy Free Shipping on all orders."
        />
        <meta
          name="keywords"
          content="KUKUNAMKEEN, Kachori, Sweets, Jamnagari Kachori, Namkeen, Free Shipping, Indian Snacks, Jamnagar"
        />
        <link rel="canonical" href="https://kukunamkeen.in/" />
      </Helmet>

      {/* First-visit Welcome Modal */}
      <WelcomeModal />

      {/* 1. Hero Image Slider */}
      <HomeSlider />

      {/* 2. About Section */}
      <AboutSection />

      {/* 3. Feature Icons (No Palm Oil, Premium Quality, etc.) */}
      <SpecifySection />

      {/* 4. Category Grid (Yellow Background) */}
      <CategorySection />

      {/* 5. Featured Products */}
      <FeaturedProducts />

      {/* 6. Gallery – Clip-path Hover */}
      <GallerySection />

      {/* 7. Reviews Slider */}
      <ReviewsSection />

      {/* 8. Quick Contact Form */}
      <ContactFormSection />

      {/* 9. Blogs Slider */}
      <BlogsSection />

      {/* 10. Also Available On (Amazon / Zomato / Mirchi) */}
      <AvailableOn />

      <MarqueeStrip speed={20} pauseOnHover={true} />
    </>
  );
};

export default MainContent;



